
/**
 * 
 */

import React from 'react';


class Button extends React.Component {

  constructor( props ) {
    super( props );
    
    this.handleClick = this.handleClick.bind(this);
  }


  handleClick(event) {
    
  }


  render() {

    let classeNames = "btn ";

    if( typeof this.props.className !== "undefined" ){
      classeNames = classeNames + this.props.className;
    }

    return (
      <a href="#/" className={classeNames} onClick={this.handleClick}>
        {this.props.children}
      </a>
    );
  }

}

export default Button; 